export const ISSUES_FOR_SLICING_REQUEST = "ISSUES_FOR_SLICING_REQUEST";
export const ISSUES_FOR_SLICING_SUCCESS = "ISSUES_FOR_SLICING_SUCCESS";
export const ISSUES_FOR_SLICING_FAILED = "ISSUES_FOR_SLICING_FAILED";